/**
 * Generate a stable hash from a string
 * Used for creating unique keys from content
 */
export const generateStableId = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash).toString(36);
};

/**
 * Generate a unique key for FAQ items
 */
export const getFaqKey = (question, index) => {
  return `faq-${generateStableId(question)}-${index}`;
};

/**
 * Generate a unique key for list items
 */
export const getListItemKey = (item, index) => {
  if (item.id) return item.id;
  if (typeof item === 'string') return `item-${generateStableId(item)}-${index}`;
  if (typeof item === 'object' && item.question) return getFaqKey(item.question, index);
  return `item-${index}`;
};
